"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentMembersStep = void 0;
const react_1 = __importDefault(require("react"));
const stream_chat_react_1 = require("stream-chat-react");
const i18n_1 = require("@app/util/i18n");
const ui_1 = require("@app/component/ui");
const ac_1 = require("@app/ac");
const store_1 = require("@app/store");
const error_handler_1 = require("@app/util/error-handler");
const useChannelMembers_1 = require("../useChannelMembers");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
function CurrentMembersStep({ goToAddMembersStep, }) {
    const { channel } = (0, stream_chat_react_1.useChatContext)();
    const [members, setMembers] = (0, useChannelMembers_1.useChannelMembers)();
    const dispatch = (0, store_1.useRootDispatch)();
    const me = (0, store_1.useRootSelector)((state) => state.me);
    const isLastMember = members.length === 1;
    const isGroupChat = channel?.type === 'group';
    const meAsChannelMember = me.id ? channel?.state.members[me.id] : undefined;
    const isModerator = meAsChannelMember?.channel_role === 'channel_moderator';
    let isOwner = false;
    if (me.id && meAsChannelMember) {
        if (meAsChannelMember.role === 'owner') {
            isOwner = true;
        }
        // @ts-expect-error
        if (channel?.data?.created_by?.id === me.id) {
            isOwner = true;
        }
    }
    const onRemove = react_1.default.useCallback(async (memberToDelete) => {
        if (!channel?.removeMembers)
            return;
        const removingMyself = me.id === memberToDelete.id;
        try {
            if (removingMyself) {
                await dispatch((0, ac_1.setModal)(null));
                if (isOwner && isLastMember) {
                    await channel.delete();
                    return;
                }
            }
            else {
                setMembers((current) => current.filter((member) => member.id !== memberToDelete.id));
            }
            await channel.removeMembers([memberToDelete.id]);
        }
        catch (error) {
            if (!removingMyself) {
                setMembers((current) => [memberToDelete, ...current]);
            }
            console.error('Remove chat member failed', { error });
            (0, error_handler_1.processErrors)([], (0, maybe_unwrap_1.unwrapMaybe)((0, i18n_1.t)('ERR_MESSAGE.error')));
        }
    }, [channel, isOwner, me.id, isLastMember]);
    react_1.default.useEffect(() => {
        if (!channel) {
            void dispatch((0, ac_1.setModal)(null));
        }
    }, [channel]);
    if (!channel)
        return null;
    return (react_1.default.createElement(ui_1.Modal, { size: ui_1.Modal.SIZES.M, headerContent: react_1.default.createElement("div", { className: 'ds-title' }, (0, i18n_1.t)('USERS')), sections: [
            react_1.default.createElement("div", { key: 'first-section' },
                isGroupChat && (isOwner || isModerator) ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(ui_1.Button, { key: 'add-member', style: 'BORDERLESS', ico: 'people', onClick: goToAddMembersStep }, (0, i18n_1.t)('ADD')),
                    react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.VERTICAL, size: ui_1.Spacing.SIZES.SIZE_16 },
                        react_1.default.createElement(ui_1.Separator, null)))) : null,
                react_1.default.createElement(ui_1.EmployeeList, { key: 'members', employees: members, onRemove: onRemove, canBeRemoved: (member) => {
                        let canBeRemoved = false;
                        if (isModerator || member.id === me.id)
                            canBeRemoved = true;
                        if (isOwner) {
                            if (member.id === me.id && !isLastMember)
                                canBeRemoved = false;
                            else
                                canBeRemoved = true;
                        }
                        if (!isGroupChat)
                            canBeRemoved = false;
                        return canBeRemoved;
                    } })),
        ] }));
}
exports.CurrentMembersStep = CurrentMembersStep;
